import React from 'react';
import { ICenterContainer } from '../../types/CenterContainer.types';

const CenterContainer: React.FC<ICenterContainer> = (props) => {
  return (
    <div className="flex justify-center">
      <div className="relative max-w-app-column w-full">
        {props.children}
      </div>
    </div>
  );
};

export default CenterContainer;
